import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'

// Import des vues
import LoginView from '@/views/LoginView.vue'
import HomeView from '@/views/HomeView.vue'
import DashboardView from '@/views/DashboardView.vue'
import PersonnelView from '@/views/PersonnelView.vue'
//import PointageCalendrierView from '@/views/PointageCalendrierView.vue'
//import ShiftsView from '@/views/ShiftsView.vue'
//import ShiftsAssignmentView from '@/views/ShiftsAssignmentView.vue'
//import SitesAssignmentView from '@/views/SitesAssignmentView.vue'
//import ParametresView from '@/views/ParametresView.vue'
//import AdminEtablissementView from '@/views/AdminEtablissementView.vue'
import ProfileView from '@/views/ProfileView.vue'
import AgentProfileView from '../views/AgentProfileView.vue'
import AgentEditView from '../views/AgentEditView.vue'
import PointageView from '../views/PointageView.vue'
import ChangePasswordView from '../views/ChangePasswordView.vue'
import PointageReportingView from '../views/PointageReportingView.vue'
import ShiftDetails from '../views/ShiftDetails.vue'
import ShiftStats from '../views/ShiftStats.vue'
import ShiftCalendar from '../views/ShiftCalendar.vue'
import SiteAssignmentView from '../views/SiteAssignmentView.vue'
import FonctionsView from '../views/FonctionsView.vue'
import GradesView from '../views/GradesView.vue'
import DirectionsView from '../views/DirectionsView.vue'
import PaysView from '../views/PaysView.vue'
import VillesView from '../views/VillesView.vue'
import TypesCongesView from '../views/TypesCongesView.vue'
import JoursNonOuvrablesView from '../views/JoursNonOuvrablesView.vue'
import HeuresServicesView from '../views/HeuresServicesView.vue'
import PersonnelCongesView from '../views/PersonnelCongesView.vue'
import QuotasView from '../views/QuotasView.vue'
import CongesCalendarView from '../views/CongesCalendarView.vue'
import PersonnelMissionsView from '../views/PersonnelMissionsView.vue'
import PersonnelArchivesView from '../views/PersonnelArchivesView.vue'
import CardsPrintedView from '../views/CardsPrintedView.vue'
import PersonnelInfoView from '../views/PersonnelInfoView.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView,
    alias: ['/login']
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/personnel',
    name: 'Personnel',
    component: PersonnelView,
    meta: { requiresAuth: true }
  },
  {
    path: '/personnel/cartes',
    name: 'CardsPrinted',
    component: CardsPrintedView,
    meta: { requiresAuth: true }
  },
  {
    path: '/agent/:id',
    name: 'AgentProfile',
    component: AgentProfileView,
    meta: { requiresAuth: true }
  },
  {
    path: '/agent/edit/:id',
    name: 'AgentEdit',
    component: AgentEditView,
    meta: { requiresAuth: true }
  },
  {
    path: '/agent/new',
    name: 'AgentNew',
    component: AgentEditView,
    meta: { requiresAuth: true }
  },
  {
    path: '/pointage',
    name: 'PointageStats',
    component: PointageView,
    meta: { requiresAuth: true }
  },
  {
    path: '/pointage/calendrier',
    name: 'PointageCalendrier',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/PointageCalendrierView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/pointage/reporting',
    name: 'PointageReporting',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/PointageReportingView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shifts',
    name: 'PointageShifts',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/ShiftsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shifts/:id/details',
    name: 'ShiftDetails',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/ShiftDetails.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shifts/stats',
    name: 'ShiftStats',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/ShiftStats.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shifts/calendar',
    name: 'ShiftCalendar',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/ShiftCalendar.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shifts/assignment',
    name: 'ShiftAssignment',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/ShiftAssignmentView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/pointage/sites-assignment',
    name: 'SiteAssignment',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/SiteAssignmentView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePasswordView,
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres',
    name: 'Parametres',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/ParametresView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres/sites-pointage',
    name: 'SitesPointage',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/SitesPointageView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres/fonctions',
    name: 'GestionFonctions',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/FonctionsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres/grades',
    name: 'GestionGrades',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/GradesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres/directions',
    name: 'directions',
    component: () => import('../views/DirectionsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres/pays',
    name: 'pays',
    component: () => import('../views/PaysView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres/villes',
    name: 'villes',
    component: () => import('../views/VillesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres/types-conges',
    name: 'types-conges',
    component: () => import('../views/TypesCongesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres/jours-non-ouvrables',
    name: 'jours-non-ouvrables',
    component: () => import('../views/JoursNonOuvrablesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/parametres/heures-services',
    name: 'heures-services',
    component: () => import('../views/HeuresServicesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/etablissement',
    name: 'AdminEtablissement',
    component: () => import('../views/AdminEtablissementView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/personnel/conges',
    name: 'PersonnelConges',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/PersonnelCongesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/personnel/conges/quotas',
    name: 'QuotasConges',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/QuotasView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/personnel/conges/calendrier',
    name: 'CalendrierConges',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/CongesCalendarView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/personnel/missions',
    name: 'PersonnelMissions',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/PersonnelMissionsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/personnel/archives',
    name: 'PersonnelArchives',
    // Utilisation d'un import dynamique pour le chargement à la demande
    component: () => import('../views/PersonnelArchivesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView,
    meta: { requiresAuth: true, title: 'Mon Profil' }
  },
  {
    path: '/personnel/qr/:id',
    alias: ['/personnel/info/:id'],
    name: 'PersonnelQR',
    component: PersonnelInfoView,
    meta: { requiresAuth: false, title: 'Informations du Personnel' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard pour l'authentification
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // Si l'utilisateur est authentifié et essaie d'accéder à la page de login
  if (token && to.path === '/login') {
    next('/dashboard')
    return
  }
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router